
import Agents from './agents/routes'
import Roles from './roles/routes'
import Permissions from './permissions/routes'

/* eslint-disable global-require */
const Packages = r => require.ensure([], () => r(require('./Main')), 'security-bundle')

export default [
  {
    path: '/security',
    component: Packages,
    meta: { requiresAuth: true },
    children: [...Agents, ...Roles, ...Permissions]
  }
]



// WEBPACK FOOTER //
// ./src/app/security/routes.js